// When this device last opened an email of the week's picks, and which teams
// it carried -- so Home can say "Email update" once the five have changed
// since (the top-five following can swap a pick after you have sent it).
//
// Per device, in localStorage, on purpose: tapping an email action is the
// only signal the app has, and it is not proof the email went. A cleared or
// blocked store just means Home never prompts for an update.

// Season type is in the key: preseason and regular-season Week 1 are different weeks.
const key = (season, seasonType, week) => `fivepicks:emailed:${season}-${seasonType}-${week}`;

export function recordEmailed(season, seasonType, week, teams, at = Date.now()) {
  if (season == null || week == null) return;
  try {
    localStorage.setItem(key(season, seasonType, week), JSON.stringify({ at, teams }));
  } catch {
    // Private mode or blocked storage: nothing to remember with.
  }
}

export function readEmailed(season, seasonType, week) {
  if (season == null || week == null) return null;
  try {
    const raw = localStorage.getItem(key(season, seasonType, week));
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && Array.isArray(parsed.teams) ? parsed : null;
  } catch {
    return null;
  }
}

// The emailed teams no longer in your picks, in the order they were sent.
// Empty when nothing was emailed or nothing it carried has been dropped.
export function droppedSinceEmail(emailed, teams) {
  if (!emailed) return [];
  const now = new Set(teams);
  return emailed.teams.filter((team) => !now.has(team));
}
